import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  heroEye,
  heroPencilSquare,
  heroTrash,
} from '@ng-icons/heroicons/outline';
import { TableAction, TableColumn } from '../../model/admin';

@Component({
  selector: 'app-table-generic',
  imports: [CommonModule, NgIcon],
  templateUrl: './table-generic.component.html',
  viewProviders: [provideIcons({ heroPencilSquare, heroTrash, heroEye })],
})
export class TableGenericComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() actions: TableAction[] = [];

  @Input() page: number = 1;
  @Input() pageSize: number = 10;
  @Input() total: number = 0;

  @Input() showPagination: boolean = false;

  @Output() view = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() remove = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<number>();

  getNestedValue(obj: any, field: string): any {
    return field.split('.').reduce((acc, key) => acc && acc[key], obj);
  }

  nextPage(): void {
    if (this.page * this.pageSize < this.total) {
      this.pageChange.emit(this.page + 1);
    }
  }

  prevPage(): void {
    if (this.page > 1) {
      this.pageChange.emit(this.page - 1);
    }
  }
}
